export default {
  GENERAL: 'general',
  SAMPLE: 'sample',
  PARAMETERS: 'parameters',
};
